import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import Attendee from './components/Attendee';
import Moderator from './components/Moderator';
import PresenterDashboard from './components/PresenterDashboard';

import './css/App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/attendee" replace />} />
        <Route path="/attendee/:id?" element={<Attendee />} />
        <Route path="/monitor/:id?" element={<Attendee monitorScreen={true} />} />
        <Route path="/moderator/:id?" element={<Moderator />} />
        <Route path="/presenter/:id?" element={<PresenterDashboard />} />
        <Route path="/dashboard/:id?" element={<Dashboard />} />
      </Routes>
    </Router>
  );
}

export default App;
